// extracted by mini-css-extract-plugin
module.exports = {"page-loader":"PageLoader_page-loader__1RFOS","loading":"PageLoader_loading__3OZTG"};